import React from 'react';
import clsx from 'clsx';
import { IProps } from './SubscriptionBlock.interface';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import { OptimizelyForm } from '@/components/OptimizelyForm/OptimizelyForm.component';
import './SubscriptionBlock.styles.css';

export const SubscriptionBlock: React.FC<IProps> = ({
    className,
    title,
    form,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('subscriptionBlock', className)}
            backgroundColor="brand-3"
            paddingBottom="small"
            paddingTop="small"
            {...blockWrapperProps}
            layout="hero"
        >
            <ContentWrapper>
                <ContentColumn className="subscriptionBlock__content">
                    {title && (
                        <Heading
                            level={2}
                            className="subscriptionBlock__title"
                            html={title}
                        />
                    )}
                    {form && (
                        <OptimizelyForm form={form} className="subscriptionBlock__form" />
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
